import Accordion from '../../plugins/accordion.js';
const elements = document.querySelectorAll(".js-accordion");
for (const element of elements) {
  let accordion = new Accordion(element, {
    multipleOpen: true,
    defaultOpenPanels: [0],
    onOpen: (trigger, panel) => {},
    onClose: (trigger, panel) => {}
  });
}

// accordion.destroy()
// accordion.init()
